<template>
    <div class="c-box p-5">
        <div class="c-box__header mb-5">
            <div class="c-box__title text-center text-uppercase">
                2FA Setup
            </div>
        </div>

        <div class="c-box__content">
            <template v-if="has_error">
                Error loading 2FA data
            </template>
            <template v-else-if="has_data === false">
                Loading data ...
            </template>
            <template v-else>
                <template v-if="twofa_activated === false">
                    <div class="alert alert-info">
                        Your account administrator has requested that two factor authentication should be enabled on
                        your account
                    </div>
                    2FA Authenticator Code :
                    <pre>{{ two_fa_secret }}</pre>
                    <br />
                    Enter the secret code in your 2FA Authenticator or scan the following QR code<br />
                    <qrcode :value="g2fa_link_string.replace('SECRET_CODE', two_fa_secret)" :options="{ width: 200 }"></qrcode><br />

                    <div class="c-form">
                        <div class="row form-group c-form__group">
                            <label for="verification_code" class="col-12 c-form__label">Enter verification code:</label>
                            <div class="col-12">
                                <b-form-input
                                    id="verification_code"
                                    v-model.trim="verification_code"
                                    class="c-form__field"
                                ></b-form-input>
                            </div>
                        </div>
                        <div class="row form-group c-form__group">
                            <div class="col-12">
                                <button class="c-btn c-btn--success" @click="activate_2fa">
                                    Activate 2FA
                                </button>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <p class="alert alert-success">Google 2FA Activated!</p>
                    <router-link :to="{ name: 'login.main' }" class="c-btn c-btn-default">
                        Sign In
                    </router-link>
                </template>
            </template>
        </div>
        <twofa-setup-ccs-modal></twofa-setup-ccs-modal>
    </div>
</template>

<script>
import CcsModal from "@/components/CcsModal.vue";

export default {
    metaInfo: {
        title: "Force 2FA"
    },

    components: {
        TwofaSetupCcsModal: CcsModal
    },

    mounted() {
        this.load_data();
    },

    props: {},

    data: function() {
        return {
            has_data: false,
            has_error: false,
            two_fa_secret: 0,
            verification_code: "",
            twofa_activated: false
        };
    },

    watch: {},

    computed: {
		g2fa_link_string: function() {
			return (
				"otpauth://totp/" +
				encodeURI(this.logged_in_user_email) +
				"?secret=SECRET_CODE" +
				"&issuer=" + encodeURI("CCS " + " (ID: " + this.logged_in_company_id + ")")
			);
		},
        logged_in_user_email: function() {
            return this.$store.state.user.user_data.email;
        },
        logged_in_company_id: function() {
            return this.$store.state.user.user_data.company_id;
        }
    },

    methods: {
        load_data: function() {
            this.$store.dispatch("user/Pre2FAGet2FASecret").then(
                (success_data) => {
                    this.twofa_data_loaded(success_data);
                },
                (error_data) => {
                    this.has_error = true;
                    this.$modal.show("twofa-setup-ccs-modal-dialog", {
                        type: "error",
                        title: "Error loading 2fa data",
                        text: error_data,
                        buttons: [
                            {
                                title: "Close",
                                default: true // Will be triggered by default if 'Enter' pressed.
                            }
                        ]
                    });
                    return;
                }
            );
        },

        twofa_data_loaded: function(two_fa_secret) {
            if (two_fa_secret.secret) {
                this.two_fa_secret = two_fa_secret.secret;
                this.has_data = true;
            } else {
                this.has_error = true;
            }
        },

        activate_2fa: function() {
            let payload = {
                secret: this.two_fa_secret,
                verify: this.verification_code
            };

            this.$store.dispatch("user/Pre2FAActivate2FA", payload).then(
                (success_data) => {
                    this.twofa_activated = true;
                },
                (error_data) => {
                    this.$modal.show("twofa-setup-ccs-modal-dialog", {
                        type: "error",
                        title: "Error processing activation data",
                        text: error_data,
                        buttons: [
                            {
                                title: "Close",
                                default: true // Will be triggered by default if 'Enter' pressed.
                            }
                        ]
                    });
                    return;
                }
            );
        }
    }
};
</script>
